import type {
  OffersPageThemedContainer,
  ThemedContainer,
} from '@trmediaab/zebra';
import { baseTheme } from '@trmediaab/zebra';

const { space: baseSpace } = baseTheme;

const container: ThemedContainer & OffersPageThemedContainer = {
  common: {
    mx: 'auto',
  },
  variants: {
    default: {
      maxWidth: '1170px',
      px: '15px',
    },
    offersPage: {
      px: ['15px', baseSpace['3,5'], null, baseSpace['4']],
    },
  },
};

export default container;
